export const CompaniesColumns = [
    {
        name: 'ID',
        key: 'id',
    },
    {
        name: 'Компания',
        key: 'name',
    },
    {
        name: 'Статус',
        key: 'status',
    },
    {
        name: 'БИН',
        key: 'bin',
    },
    {
        name: 'Последняя дата LTL заказа',
        key: 'latest_ltl_order_date',
    },
    {
        name: 'Последняя дата FTL заказа',
        key: 'latest_ftl_order_date',
    },
    {
        name: 'Биллинг',
        key: 'billing',
    },
    {
        name: 'Тариф',
        key: 'shipment_tariff_name',
    },
    {
        name: 'E-mail',
        key: 'contact_email',
    },
    {
        name: 'Менеджер',
        key: 'manager',
    },
    {
        name: 'Дата создания',
        key: 'created_at',
    },
    {
        name: 'Признак',
        key: 'company_source_name',
    },
    {
        name: 'Услуги',
        key: 'contractServices'
    }
]
